module.exports = __webpack_public_path__ + "static/careDemo5-6e7b7ff9bb5f9bb00d8b1533a06c16ef.svg";